<template>
  <div class="error-page">
    <app-header
        :position="'fixed'"
        :top="'0px'"
        :background="'transparent'"
        @clickMenu="change_menu(context, true)"
    />


    <div class="error-page__title">
      Ошибка!
    </div>

    <div class="error-page__descr">
      При попытке оплаты произошла ошибка, попробуйте оплатить еще раз.
    </div>

    <div class="error-page__wrapper-buttons">
      <div class="error-page__payment" @click="payment()">
        Оплатить снова
      </div>
      <div class="error-page__back" @click="$router.push('/')">
        <span>Вернуться на главную</span>
      </div>
    </div>

    <transition
        name="fade-menu"
        appear
        mode="out-in"
    >
      <app-menu
          v-if="menu"
          idLogoMenu="header-component__menu"
          @clickLink="change_menu(context, false)"
          @clickOutside="change_menu(context, false)"
      />
    </transition >

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >
      <app-overlay
          v-if="overlay"
      />
    </transition>

    <transition
        name="fade-overlay"
        appear
        mode="out-in"
    >

      <app-alert
          v-if="error.status"
          buttonText="Попробовать еще раз"
          :text="error.text"
          @clickGrowButtonPopup="() => {
              error.status = false
              overlay = false
              loading = false
            }"
      />

    </transition>
  </div>
</template>

<script>

const AppHeader = () => import('@/components/header.vue')
const AppMenu = () => import('@/components/menu.vue')
const AppOverlay = () => import('@/components/overlay.vue')
const AppAlert = () => import('@/components/popups/error')
const payment = () =>  import("@/views/payment/api")

import change_menu from "@/views/theme/modules/change_menu";

export default {
  data() {
    return {
      context: this,
      overlay: false,
      menu: false,
      error: {
        status: false,
        text: ''
      }
    }
  },
  components: {
    AppHeader,
    AppMenu,
    AppOverlay,
    AppAlert
  },
  methods: {
    change_menu,
    async payment() {
      payment().then(data => {
        data.default({
          order: this.order,
          resolve: (data) => {
            this.overlay = false
            this.error.status = false
            this.error.text = ''
            window.location = data.url;
          },
          reject: (e) => {
            console.log(e)
            this.overlay = true
            this.error.status = true
            this.error.text = e.error
          }
        })
      })
    }
  },
  computed: {
    order() {
      return this.$store.getters['auth/order']
    }
  }
}
</script>

<style lang="less">
  .error-page {
    background-color: #2F1F4C;
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #FFFFFF;
    text-align: center;
    min-height: 300px;
  }

  @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

  .error-page__title {
    color: #FFFFFF;
    font-size: 28px;
    font-family: 'Montserrat-Bold';
  }


  @import '~/assets/fonts/roboto/Roboto-Light.less';

  .error-page__descr {
    color: #FFFFFF;
    max-width: 275px;
    text-align: center;
    font-size: 15px;
    font-family: 'Roboto-Light';
    margin-top: 24px;
  }

  .error-page__wrapper-buttons {
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    align-items: center;
    padding: 0px 16px;
    font-family: 'Montserrat-Medium';
  }

  @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

  .error-page__payment {
    max-width: 343px;
    width: 100%;
    background: #FFFFFF;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    border-radius: 5px;
    color: #31283D;
    cursor: pointer;
    transition: transform .2s linear;
  }

  .error-page__payment:active {
    transform: scale(.98);
  }

  .error-page__back {
    margin-top: 24px;
    color: #FFFFFF;
    border-bottom: 1px dashed #FFFFFF;
    margin-bottom: 30px;
    cursor: pointer;
  }

</style>